import { type FC, type ReactNode } from 'react';
import classnames from 'classnames';

import ArrowRight from 'dibs-icons/exports/legacy/ArrowRight.ts';
import { Link } from 'dibs-elements/exports/Link.tsx';

import dibsCss from 'dibs-css';

const GetHelpZendeskIntroLink: FC<{
    onClick: () => void;
    children: ReactNode;
    isLast?: boolean;
    icon?: ReactNode;
}> = ({ onClick, children, isLast, icon }) => {
    return (
        <Link onClick={onClick} underline="none" className={dibsCss.wFull}>
            <span
                className={classnames(
                    !isLast && [dibsCss.borderB, dibsCss.borderBDolphin, dibsCss.borderBSolid],
                    dibsCss.pySmall,
                    dibsCss.sassyFontBodyMediumHeavy,
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.justifyBetween,
                    dibsCss.wFull
                )}
            >
                <span
                    className={classnames(
                        dibsCss.flex,
                        dibsCss.itemsCenter,
                        dibsCss.textPitchblack
                    )}
                >
                    <span className={dibsCss.mrSmall}>{icon}</span>
                    {children}
                </span>
                <ArrowRight
                    className={classnames(
                        dibsCss.hSmaller,
                        dibsCss.wSmaller,
                        dibsCss.fillPitchblack
                    )}
                />
            </span>
        </Link>
    );
};

export { GetHelpZendeskIntroLink };
